import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

/**
 * A class with style.
 */
export default class SendByEmailStyle {
	/**
	 * Returns styles.
	 *
	 * @param options The props.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { spacing, color } = options.theme;

		return css`
			.container {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
			}

			kompis-input {
				display: flex;
				align-self: stretch;
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			kompis-text {
				color: ${color.neutral.grey700};
			}

			skapa-inline-message {
				margin-top: ${spacing.space50 / 16}rem;
			}

			.message {
				display: block;
				margin-top: ${spacing.space50 / 16}rem;
				font-size: 0;
			}
		`;
	}
}
